import axiosInstance from '../config/axios';

interface LoginResponse {
  access_token: string;
}

interface LoginCredentials {
  username: string;
  password: string;
}

export const TOKEN_KEY = 'token_tweet_crawler_access_token';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await axiosInstance.post<LoginResponse>('/auth/login', credentials);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    window.location.href = '/login';
  },

  getToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
  },

  setToken: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem(TOKEN_KEY);
  }
}; 